module.exports = __webpack_public_path__ + "static/media/php.35a8645d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/php.png
// module id = 166
// module chunks = 0